import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, AppConfig } from '../app-config';
import { IAiRepository } from './Iai.repository';
import { CircleDetection } from './models';


@Injectable({ providedIn: 'root' })
export class AiRepository implements IAiRepository {

	constructor(private readonly httpClient: HttpClient, @Inject(APP_CONFIG) private readonly config: AppConfig) { }

	circleDetection(image: File): Observable<CircleDetection> {
		const formData = new FormData();
		const filename = image.name.replace(/[^\p{L}\d\s]+/gu, '_');
		formData.set('image', image, filename);
		return this.httpClient.post<CircleDetection>(this.config.domainAiAPI + '/CircleDetection', formData);
	}
}
